import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Building from "./Building";
import Bills from "./Bills";
import AssemblyInformations from "./AssemblyInformations";
import Units from "./Units";
import Categories from "./Categories";
import PayExpenses from "./PayExpenses";
import Expenses from "./Expenses";
import { Header } from '../Header';
import { Footer } from '../Footer';
import Notifications from './Notifications';

export default class Buildings extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'building',
            IsV2: true,
            data: null,
            loading: true,
            systemModuleId: 29,
            moduleAccessStatus: 1
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Building Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Building Caller={this} /> });
    }
    showBills(buildingId) {
        this.showComponents({
            component: <Bills BuildingId={buildingId} Caller={this} />
        });
    }
    showNotifications(buildingId) {
        this.showComponents({
            component: <Notifications BuildingId={buildingId} Caller={this} />
        });
    }
    showAssemblyInformations(buildingId) {
        this.showComponents({
            component: <AssemblyInformations BuildingId={buildingId} Caller={this} />
        });
    }
    showReceipts(buildingId) {
        this.showComponents({
            component: <PayExpenses BuildingId={buildingId} Caller={this} />
        });
    }
    showUnits(buildingId) {
        this.showComponents({
            component: <Units BuildingId={buildingId} Caller={this} />
        });
    }
    showCategories() {
        this.showComponents({
            component: <Categories Caller={this} />
        });
    }
    showExpense(type) {
        this.showComponents({
            component: <Expenses Type={type} Caller={this} />
        });
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.onAdd()} className="hand btn btn-primary"><em className="icon ni ni-plus"></em><span>افزودن ساختمان جدید</span></a>
                                            <a onClick={e => this.showExpense(6)} className="hand btn btn-danger me-2 ms-2"><em className="icon ni ni-list"></em><span>دفتر هزینه</span></a>
                                            <a onClick={e => this.showExpense(5)} className="hand btn btn-warning me-2 ms-2"><em className="icon ni ni-list"></em><span>دفتر درآمد</span></a>
                                            <a onClick={e => this.showCategories()} className="hand btn btn-success"><em className="icon ni ni-list"></em><span>گروه ها</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    {this.isEmpty(this.state.data.records) ?
                        <div className="card card-bordered card-stretch">
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>شما در حال حاضر هیچ ساختمانی ایجاد نکرده اید</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row g-gs">
                            {this.state.data.records.map((record, index) =>
                                <div className="col-sm-6 col-lg-6 col-xxl-3">
                                    <div className="card card-bordered h-100">
                                        <div className="card-inner">
                                            <div className="project">
                                                <div className="project-head">
                                                    <a onClick={e => this.onEdit(record.id)} className="hand project-title">
                                                        <div className="project-info">
                                                            <h6 className="title">{record.title}</h6>
                                                            <span className="sub-text">ایجاد: {record.createDateString}</span>
                                                        </div>
                                                    </a>
                                                    <div className="drodown">
                                                        <a href="#" className="dropdown-toggle btn btn-sm btn-icon btn-trigger mt-n1 me-n1" data-bs-toggle="dropdown" aria-expanded="false"><em className="icon ni ni-more-h"></em></a>
                                                        <div className="dropdown-menu dropdown-menu-end">
                                                            <ul className="link-list-opt no-bdr">
                                                                <li><a onClick={e => this.confirmRemove(record.id)} className="hand"><em className="icon ni ni-trash"></em><span>حذف ساختمان</span></a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="project-details">
                                                    <p>آدرس: {record.address}</p>
                                                </div>
                                                <div className="project-meta">
                                                    <a onClick={e => this.showBills(record.id)} className="hand">
                                                        <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em> صورتحسابها</span>
                                                    </a>
                                                    <a onClick={e => this.showNotifications(record.id)} className="hand text-success">
                                                        <span className="nk-menu-text"><em className="icon ni ni-bell"></em> اطلاعیه ها</span>
                                                    </a>
                                                    <a onClick={e => this.showAssemblyInformations(record.id)} className="hand text-warning">
                                                        <span className="nk-menu-text"><em className="icon ni ni-calender-date"></em> مجامع</span>
                                                    </a>
                                                    <a onClick={e => this.showReceipts(record.id, 1)} className="hand text-danger">
                                                        <span className="nk-menu-text"><em className="icon ni ni-coin-alt"></em> دریافت و پرداخت</span>
                                                    </a>
                                                    <a onClick={e => this.showUnits(record.id)} className="hand text-info">
                                                        <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em> واحدها</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}